import React from 'react';

// Top progress bar; its scaleX transform is driven by useScrewAnimation.
const ScrollProgress: React.FC = () => <div className="scroll-progress" aria-hidden="true"></div>;

export default ScrollProgress;
